module.exports = __webpack_public_path__ + "img/rgb_white.2cc98549.png";